/** Página para mostrar as informações de determinada pasta */
import React, { Component } from "react";
import api from "../../services/api";

import Base from "../../components/Base";
import Loading from "../../components/Loading";

import { Alert, Button, Drawer, Tabs } from "antd";

import PastaForm from "./components";
import PastaInfo from "./components/PastaInfo";
import PastaResumo from "./components/PastaResumo";
import Acordos from "./Acordos";
import { Contratos } from "./Contratos";

import "./styles.css";
import { isSuperUser } from "../../utils/is-superuser";

const { TabPane } = Tabs;

export default class Pasta extends Component {
  /** Mostra informações de determinada pasta */
  state = {
    loading: true,
    pasta: null,
    filtro: null,
    error: null,
    showDrawer: false,
    activeTab: "acordos",
    resumo: null,
    loadingResumo: false
  };

  /** Component load */
  componentDidMount() {
    this.handleInformations();
  }

  /** Busca resumo/estatísticas da pasta */
  handleResumo = async (pastaId) => {
    if (!pastaId) return;

    this.setState({ loadingResumo: true });

    try {
      const response = await api.get(`/pasta/pastas/${pastaId}/resumo/`);
      this.setState({
        resumo: response.data,
        loadingResumo: false
      });
    } catch (error) {
      console.error('Erro ao buscar resumo:', error);
      this.setState({ loadingResumo: false });
    }
  };

  componentWillReceiveProps(props) {
    /**
     * Caso as propriedades do componente sejam atualizadas
     * (o usuário pesquisou outra pasta) esse método é chamado
     * e em seguida atualiza as informações da pasta na tela
     * do usuário.
     */
    this.handleInformations(props);
  }

  /** Redirect */
  handleRedirect = path => {
    this.props.history.push(path);
  };

  /** Busca informações da pasta */
  handleInformations = async (props = this.props) => {
    const { id } = props.match.params;

    if (!this.state.loading) this.setState({ loading: true });

    /** Obtém informações da pasta */
    await api
      .get(`/pasta/pastas/${id}/`)
      .then(response => {
        this.setState({
          pasta: response.data,
          filtro: response.data.filtro,
          loading: false
        });

        // Buscar resumo após carregar a pasta
        this.handleResumo(id);
      })
      .catch(error => {
        let message = "Não foi possível obter informações da pasta.";

        if (error.response) {
          if (error.response.status == 404) {
            message = "Pasta não encontrada.";
          }
        }

        this.setState({
          error: message,
          loading: false
        });
      });
  };

  showDrawer = () => {
    this.setState({
      ...this.state,
      showDrawer: true
    });
  };

  closeDrawer = () => {
    this.setState({
      ...this.state,
      showDrawer: false
    });
  };

  getDrawer = () => {
    return (
      <Drawer
        title="Editar"
        placement="right"
        closable={true}
        onClose={() => this.closeDrawer()}
        visible={this.state.showDrawer}
        width={"75%"}
      >
        <PastaForm pasta={this.state.pasta} />
      </Drawer>
    );
  };

  render() {
    const isAdmin = isSuperUser();
    console.log(this.state.resumo)

    if (this.state.error)
      // Caso ocorra algum erro, mostra-o para o usuário
      return (
        <div>
          <br />
          <Alert type="error" message={this.state.error} />
        </div>
      );

    if (this.state.loading)
      return (
        <div>
          <br />
          <Loading />
        </div>
      );

    const pasta = this.state.pasta;
    const { id } = this.props.match.params;

    return (
      <Base
        title={this.state.pasta.pasta}
        subTitle={this.state.pasta.cooperado}
        extra={[
          isAdmin && (
            <Button
              key={3}
              type="primary"
              className="btn-green"
              onClick={() => this.handleRedirect(`/acordo/create/${id}`)}
            >
              Cadastrar acordo
            </Button>
          )
        ]}
      >
        {this.getDrawer()}

        {/* Card de Informações Rápidas */}
        <PastaInfo pasta={pasta} onEdit={this.showDrawer} />

        {/* Dashboard de Resumo */}
        <PastaResumo
          estatisticas={this.state.resumo && this.state.resumo.estatisticas}
          loading={this.state.loadingResumo}
        />

        {/* Tabs com Acordos e Contratos */}
        <Tabs
          activeKey={this.state.activeTab}
          onChange={(key) => this.setState({ activeTab: key })}
        >
          <TabPane tab="Acordos" key="acordos" style={{ fontSize: "18px", fontWeight: "500" }}>
            <Acordos pasta={pasta} />
          </TabPane>

          <TabPane tab="Contratos (TXT)" key="contratos" style={{ fontSize: "18px" }}>
            {pasta.contrato ? (
              <Contratos id_devedor={pasta.contrato} />
            ) : (
              <Alert
                message="Nenhum contrato vinculado"
                description="Esta pasta não possui contratos vinculados do TXT."
                type="info"
                showIcon
              />
            )}
          </TabPane>
        </Tabs>
      </Base>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Pasta/index.js